import Cookies from "js-cookie";

const STORAGE_KEY = 'wk-resource';

const setResourceCookie = (resource, remember) => {
    Cookies.set(`${STORAGE_KEY}_${resource}`, resource, {expires: remember ? 365 : null});
}

const getResourceCookie = (resource) => {
    if (resource) {
        return Cookies.get(`${STORAGE_KEY}_${resource}`);
    } else {
        return Cookies.get(STORAGE_KEY);
    }
}

export {
    setResourceCookie,
    getResourceCookie
}



// WEBPACK FOOTER //
// ./src/utils/resource.js